import { Stack, Text, Title } from "@mantine/core"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

type LaunchTraceabilityModalHeaderProps = {
  tracedProductsCount: number | undefined
  totalProducts: number | undefined
  currentTraceabilityCoverage: number | undefined
  isTraceabilityJobRunning: boolean
}

export const LaunchTraceabilityModalHeader = ({
  tracedProductsCount,
  totalProducts,
  currentTraceabilityCoverage,
  isTraceabilityJobRunning,
}: LaunchTraceabilityModalHeaderProps) => {
  const { t } = useTranslation("traceability")

  const description = useMemo(() => {
    if (isTraceabilityJobRunning) {
      return t("launch.modal.header.description.runningJob")
    }

    if (tracedProductsCount) {
      return t("launch.modal.header.description.default", {
        tracedProductsCount,
        totalProducts,
        currentTraceabilityCoverage,
      })
    }

    return t("launch.modal.header.description.noTraceabilityCampaign")
  }, [
    t,
    tracedProductsCount,
    totalProducts,
    currentTraceabilityCoverage,
    isTraceabilityJobRunning,
  ])

  return (
    <Stack>
      <Title order={3}>{t("launch.modal.header.title")}</Title>
      <Text fz="sm">{description}</Text>
    </Stack>
  )
}
